<div id="rrhh-data-container">
  <!-- top block -->
  <div id="top-block">
    <p class="heading-02-semi-bold grey-900 title">Datos RE/MAX</p>
    <!-- Estado QR -->
    <div class="row-container">
      <div class="item-container">
        <p class="subheading-01-semi-bold grey-800 sub-title">Estado QR</p>
        <div id="dropdown-state-qr">
          <qr-dropdown
            [config]="this.dropdownEstado"
            (change)="changeStatus($event)"
            [hasError]="this.errors.status"
            [selected]="this.data.status"
            [isDisabled]="!this.data.id"
          ></qr-dropdown>
        </div>
      </div>
      <!-- Estado QR -->
      <!-- Baja QR -->

      <div
        class="item-container right"
        *ngIf="this.data.id && this.data.downDateQR"
      >
        <p class="subheading-01-semi-bold grey-800 sub-title">Baja QR</p>
        <div id="input-bajar-qr">
          <qr-date-picker
            [config]="deactivationDateQR"
            (datepickerChange)="deactivationDateQRChange($event)"
            [isDisabled]="this.data.status != 'Inactivo'"
            [hasError]="this.errors.downDateQR"
          ></qr-date-picker>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.downDateQR }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">Ingrese una fecha de baja</p>
        </div>
      </div>
      <!-- Estado QR -->
    </div>
  </div>
  <!-- top block -->

  <!-- bottom block -->
  <div id="bottom-block">
    <!-- First row -->
    <div class="row-container">
      <!-- ID Agente -->
      <div class="item-container">
        <div class="flex">
          <p class="subheading-01-semi-bold grey-800 sub-title">ID Agente</p>
          <div class="optional-tag-container mb-3">
            <p class="caption-02-bold primary-900">Opcional</p>
          </div>
        </div>
        <div id="dropdown-state-qr">
          <qr-input
            [isDisabled]="!allowAgentIdManual"
            [config]="inputIdAgente"
            (valueChange)="changeInputIDAgente($event)"
            [hasError]="this.errors.agentId"
            [value]="this.data.agentId ?? ''"
          ></qr-input>
        </div>
        <p class="caption-01-regular grey-700 hint">
          ID Oficina + ID Agente Ej.: 42004331
        </p>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.agentId }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">Ingrese un ID válido</p>
        </div>
      </div>
      <!-- ID Agente -->
      <!-- Alta RE/MAX -->
      <div class="item-container right">
        <p class="subheading-01-semi-bold grey-800 sub-title">Alta RE/MAX</p>
        <div id="dropdown-state-qr">
          <qr-date-picker
            [config]="registrationDateREMAX"
            (datepickerChange)="registrationDateAltaREMAXChange($event)"
            [hasError]="errors.estateDate"
            [isDisabled]="this.NODE != this.NODE_GLOBAL"
          ></qr-date-picker>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.estateDate }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">Ingrese una fecha válida</p>
        </div>
      </div>
      <!-- Alta RE/MAX -->
    </div>
    <!-- First row -->
    <!-- Second row -->
    <div
      class="row-container"
      *ngIf="this.data.mainstreetId || this.data.mainstreetDate"
    >
      <!-- Membresía Anual ID -->
      <div class="item-container" *ngIf="this.data.mainstreetId">
        <p class="subheading-01-semi-bold grey-800 sub-title-2">
          Membresía Anual ID
        </p>
        <p class="paragraph-02-bold grey-600">{{ this.data.mainstreetId }}</p>
      </div>
      <!-- Membresía Anual ID -->
      <!-- Membresía Anual ID -->
      <div class="item-container right" *ngIf="this.data.mainstreetDate">
        <p class="subheading-01-semi-bold grey-800 sub-title-2">
          Fecha Pago Membresía
        </p>
        <p class="paragraph-02-bold grey-600">
          {{ this.data.mainstreetDate | date: "dd/MM/yyyy" }}
        </p>
      </div>
      <!-- Membresía Anual ID -->
    </div>
    <!-- Second row -->
    <div class="row-container" *ifNodeShow="[NODE_DO]">
      <!-- Split de Agente -->
      <div class="item-container">
        <p class="paragraph-02-bold grey-600 sub-title">Split de Agente</p>
        <div id="dropdown-state-qr">
          <qr-dropdown
            [config]="this.dropdownAgentsType"
            (change)="changeAgentTypeDO($event)"
            [hasError]="this.errors.agentType"
            [isDisabled]="this.dropdownAgentsType.options.length == 0"
            [selected]="this.agentType"
          ></qr-dropdown>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.agentType }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            Ingrese un split de agente
          </p>
        </div>
      </div>
      <!-- Tipo de Agente -->
    </div>
    <ng-container *ifNodeShow="[NODE_DO]">
      <div class="split-error-container" *ngIf="errors.splitTeam">
        <qr-icon name="error" color="error-700"></qr-icon>
        <p>{{ splitErrorMessage }}</p>
      </div>
    </ng-container>

    <!-- Third row -->
    <div class="row-container" *ifNodeShow="[NODE_DO]">
      <!-- Tipo de Agente -->
      <div class="item-container">
        <p class="paragraph-02-bold grey-600 sub-title">Tipo de Agente</p>
        <div id="dropdown-state-qr">
          <qr-dropdown
            [config]="this.dropdownAgentsLevelType"
            (change)="changeAgentLevelTypeDO($event)"
            [hasError]="this.errors.agentLevelType"
            [isDisabled]="this.dropdownAgentsLevelType.options.length == 0"
            [selected]="getSelectedAgentLevelLabel()"
          ></qr-dropdown>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.agentLevelType }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">Ingrese un tipo de agente</p>
        </div>
      </div>
      <!-- Tipo de Agente -->
      <!-- Team -->
      <div class="item-container right team-column-wide">
        <p class="paragraph-02-bold grey-600 sub-title">Team</p>
        <div id="dropdown-state-qr">
          <qr-input-autocomplete
            [config]="inputAutocompleteTeams"
            [value]="this.data.teamName ?? ''"
            [isDisabled]="isEdit"
            (selectedChange)="inputAutocompleteChange($event)"
          ></qr-input-autocomplete>
        </div>
        <div
          class="error-container team-message--wrap"
          [ngClass]="{
            'error-height': this.errors.team
          }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">{{ errorTeamMessage }}</p>
        </div>
      </div>
      <!-- Team -->
    </div>

    <!-- Third row -->

    <!-- Third row -->
    <div class="row-container" *ifNodeHide="[NODE_DO]">
      <!-- Tipo de Agente -->
      <div class="item-container">
        <p class="paragraph-02-bold grey-600 sub-title">Tipo de Agente</p>
        <div id="dropdown-state-qr">
          <qr-dropdown
            [config]="this.dropdownAgentsType"
            (change)="changeAgentType($event)"
            [hasError]="this.errors.agentType"
            [isDisabled]="this.dropdownAgentsType.options.length == 0"
            [selected]="this.agentType"
          ></qr-dropdown>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.agentType }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">Ingrese un tipo de agente</p>
        </div>
      </div>
      <!-- Tipo de Agente -->
      <!-- Team -->
      <div
        class="item-container right team-column-wide"
        *ngIf="
          this.data.agentType === 'TEAM_JUNIOR' || showTeamTypeChangeNotice
        "
      >
        <p class="paragraph-02-bold grey-600 sub-title">Team</p>
        <div id="dropdown-state-qr">
          <qr-dropdown
            [config]="this.dropdownTeams"
            (change)="changeTeam($event)"
            [selected]="this.data.teamName ?? ''"
            [hasError]="
              this.data.agentType == 'TEAM_JUNIOR' && !this.data.teamName
            "
            [isDisabled]="
              this.dropdownTeams.options.length == 0 || showTeamTypeChangeNotice
            "
          ></qr-dropdown>
        </div>
        <div
          class="error-container team-message--wrap"
          [ngClass]="{
            'error-height': this.errors.team || showTeamTypeChangeNotice
          }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">{{ errorTeamMessage }}</p>
        </div>
      </div>
      <!-- Team -->
    </div>
    <!-- Third row -->

    <!-- Fourth row -->
    <div class="row-container">
      <!-- Fecha de ingreso -->
      <div class="item-container">
        <p class="subheading-01-semi-bold sub-title">Fecha de ingreso</p>
        <div id="dropdown-state-qr">
          <qr-date-picker
            [config]="startDate"
            (datepickerChange)="startDateChange($event)"
          ></qr-date-picker>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.beginDate }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            Seleccione una fecha de ingreso
          </p>
        </div>
      </div>
      <!-- Fecha de baja RE/MAX -->
      <div
        class="item-container right"
        *ngIf="this.data.id && this.data.statusRMX == 'Inactivo'"
      >
        <p class="subheading-01-semi-bold sub-title">Fecha de baja RE/MAX</p>
        <div id="dropdown-state-qr">
          <qr-date-picker
            [config]="deactivationDateREMAX"
            (datepickerChange)="registrationDateBajaREMAXChange($event)"
            [isDisabled]="!!this.data.statusRMX"
          ></qr-date-picker>
        </div>
      </div>
      <!-- Fecha de baja RE/MAX -->
    </div>
    <!-- Fourth row -->
    <!-- E-mail laboral -->
    <div class="row-container">
      <div class="item-container">
        <div class="flex">
          <p class="paragraph-02-bold grey-600 sub-title">E-mail laboral</p>
          <div
            class="optional-tag-container"
            *ngIf="this.NODE !== this.NODE_DO"
          >
            <p class="caption-02-bold primary-900">Opcional</p>
          </div>
        </div>
        <div id="dropdown-work-email">
          <qr-input
            [config]="inputWorkEmail"
            (valueChange)="changeInputEmail($event)"
            [hasError]="this.errors.workEmail"
            [value]="this.data.workEmail"
          ></qr-input>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.workEmail }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">Ingrese un email válido</p>
        </div>
      </div>
    </div>
    <!-- E-mail laboral -->
    <!-- Verificación -->
    <div class="row-container">
      <div class="item-container w-100">
        <div class="flex">
          <p class="subheading-01-semi-bold grey-800 sub-title">Verificación</p>
          <div class="optional-tag-container">
            <p class="caption-02-bold primary-900">Opcional</p>
          </div>
        </div>
        <div id="verification-checkbox-container">
          <div
            *ngFor="let item of this.agentVerifications"
            class="verification-item"
          >
            <mat-checkbox
              color="primary"
              [checked]="this.data.agentVerifications.includes(item.id)"
              (change)="changeVerifications(item.id)"
            >
              <p class="subheading-01-semi-bold grey-700">{{ item.name }}</p>
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <!-- Verificación -->
    <!-- Notas -->
    <div class="row-container">
      <div class="item-container w-100">
        <div class="flex">
          <p class="subheading-01-semi-bold grey-800 sub-title">Notas</p>
          <div class="optional-tag-container mb-3">
            <p class="caption-02-bold primary-900">Opcional</p>
          </div>
        </div>
        <div id="notes-container">
          <textarea
            name="notes1"
            [value]="this.data.notes"
            (keyup)="textareaChange($event)"
            id="notes"
          ></textarea>
        </div>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': this.errors.notes }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            Excede el límite de caracteres
          </p>
        </div>
      </div>
      <!-- Notas -->
    </div>
    <!-- bottom block -->
  </div>
</div>

<!-- Dialogo baja qr -->
<qr-dialog [config]="this.dialogBajaQR"></qr-dialog>
